import React from 'react';

import { distanceFilterToString, parseDistanceFilter } from '@paragon/client-tools';
import { DistanceFilter } from '@paragon/contract-library';

import { FormattedTextField, FormattedTextFieldProps } from './FormattedTextField';

export type DistanceFilterFieldProps<
  TAllowNull extends boolean = false,
  TAllowNullSubmittal extends boolean = false,
  TAllowIndeterminate extends boolean = false,
> = Omit<
  FormattedTextFieldProps<DistanceFilter, TAllowNull, TAllowNullSubmittal, TAllowIndeterminate>,
  'formatValue' | 'parseValue'
>;

export function DistanceFilterField<
  TAllowNull extends boolean = false,
  TAllowNullSubmittal extends boolean = false,
  TAllowIndeterminate extends boolean = false,
>(props: DistanceFilterFieldProps<TAllowNull, TAllowNullSubmittal, TAllowIndeterminate>) {
  return (
    <FormattedTextField<DistanceFilter, TAllowNull, TAllowNullSubmittal, TAllowIndeterminate>
      {...props}
      parseValue={(input) => {
        const filter = parseDistanceFilter(input);
        return filter ? { valid: true, value: filter } : { valid: false, value: null };
      }}
      formatValue={distanceFilterToString}
    />
  );
}
